<template>
    <div class="CourseList">

        <div class="container-fluid blue-bg centers-list pb-0">
            <div class="container align-middle">
                <form method="get">
                    <div class="row">
                        <div class="col-sm-4">
                            <div class="choose-course">
                                <select name="lang" v-model="langId">
                                    <option :value="null">{{ $t('select_language') }}</option>
                                    <option value="1">{{ $t('english_lang') }}</option>
                                    <option value="2">{{ $t('spanish_lang') }}</option>
                                    <option value="3">{{ $t('german_lang') }}</option>
                                    <option value="4">{{ $t('french_lang') }}</option>
                                    <option value="5">{{ $t('chinese_lang') }}</option>
                                    <option value="6">{{ $t('russian_lang') }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="choose-age">
                                <select name="age" v-model="ageId">
                                    <option :value="null">{{ $t('Age') }}</option>
                                    <option value="1">{{ $t('preschooler') }}</option>
                                    <option value="2">{{ $t('schoolboy_1_4_class') }}</option>
                                    <option value="3">{{ $t('parent') }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="knopka">
                                <input type="submit" :value="$t('find_course')">
                            </div>
                        </div>

                    </div>
                </form>
            </div>
        </div>

        <div class="container-fluid white-bg centers-list fr-page">
            <div class="container align-middle">
                <div class="row">
                    <div class="col-12 home-first">

                        <!-- <h1 class="title" v-if="courses.length > 0">
                            {{ $t('finded_courses') }} <span class="strong-red">{{courses.length}}</span>
                        </h1> -->
                    </div>
                </div>

                <!-- <course-list-subscription-item v-if="courses.length > 0"
                                               @order="orderSubscription"
                /> -->
                <div class="row justify-content-center" v-if="!flavorConfig.hideStudyProductsBlock">
                    <study-list-item v-for="item in studyProducts"
                                     :key="item.idstudyproduct"
                                     :studyProduct="item"
                                     @click.native="toStudyProduct(item)"
                    />
                </div>
                <div class="row" v-if="courses.length > 0">
                    <div class="col-12 my-4">
                        <!-- <div class="land-t-delimeter"></div> -->
                    </div>
                </div>

                <course-list-item v-for="(item, index) in courses"
                                  :key="item.idcourse"
                                  :last-item="index === courses.length - 1"
                                  :course="item"
                                  :demo-button-text="courseDemoButtonLabel(item)"
                                  @order="order"
                                  @demo="demo(item)"/>

                <div class="row my-5" v-if="!loading && courses.length === 0">
                  <div class="col-12 text-center">
                    <p>{{ $t('courses_not_found') }}</p>

                    <router-link to="/courses">
                      {{ $t('view_other_courses') }}
                    </router-link>
                  </div>
                </div>


            </div>
        </div>

        <Lang1 v-if="flavorConfig.courseListShowSeoTexts && langId == 1 && !ageId"/>
        <Lang1Age1 v-if="flavorConfig.courseListShowSeoTexts && langId == 1 && ageId == 1"/>
        <Lang1Age2 v-if="flavorConfig.courseListShowSeoTexts && langId == 1 && ageId == 2"/>
        <Lang1Age3 v-if="flavorConfig.courseListShowSeoTexts && langId == 1 && ageId == 3"/>
        <Lang1Age4 v-if="flavorConfig.courseListShowSeoTexts && langId == 1 && ageId == 4"/>
        <Lang2 v-if="flavorConfig.courseListShowSeoTexts && langId == 2 && !ageId"/>
        <Lang2Age2 v-if="flavorConfig.courseListShowSeoTexts && langId == 2 && ageId == 2"/>
        <Lang3 v-if="flavorConfig.courseListShowSeoTexts && langId == 3 && !ageId"/>
        <Lang3Age2 v-if="flavorConfig.courseListShowSeoTexts && langId == 3 && ageId == 2"/>
        <Lang4 v-if="flavorConfig.courseListShowSeoTexts && langId == 4 && !ageId"/>
        <Lang4Age1 v-if="flavorConfig.courseListShowSeoTexts && langId == 4 && ageId == 1"/>
        <Lang6 v-if="flavorConfig.courseListShowSeoTexts && langId == 6 && !ageId"/>



        <div class="container-fluid feedback-head-bg"></div>
        <entry/>


    </div>
</template>

<script>
    import CourseListItem from "./CourseListItem";
    import courseApi from "../data/CourseApi";
    import Entry from "./Entry";
    import Lang1 from "./CourseComponents/texts/Lang1";
    import Lang1Age1 from "./CourseComponents/texts/Lang1Age1";
    import Lang1Age2 from "./CourseComponents/texts/Lang1Age2";
    import Lang1Age3 from "./CourseComponents/texts/Lang1Age3";
    import Lang1Age4 from "./CourseComponents/texts/Lang1Age4";
    import Lang2 from "./CourseComponents/texts/Lang2";
    import Lang2Age2 from "./CourseComponents/texts/Lang2Age2";
    import Lang3 from "./CourseComponents/texts/Lang3";
    import Lang3Age2 from "./CourseComponents/texts/Lang3Age2";
    import Lang4 from "./CourseComponents/texts/Lang4";
    import Lang4Age1 from "./CourseComponents/texts/Lang4Age1";
    import Lang6 from "./CourseComponents/texts/Lang6";
    import CourseListSubscriptionItem from "./CourseListSubscriptionItem";
    import {isAuthenticated} from "../data/jwt.service";
    import userApi from "../data/UserApi";
    import studyProductApi from "../data/StudyProductApi";
    import StudyListItem from "./Study/StudyListItem";

    export default {
        name: "CourseList",
        components: {
            StudyListItem,
            CourseListSubscriptionItem,
            CourseListItem, Entry, Lang1, Lang1Age1, Lang1Age2, Lang1Age3, Lang1Age4, Lang2, Lang2Age2, Lang3, Lang3Age2, Lang4, Lang4Age1, Lang6
        },
        data() {
            return {
                courses: [],
                studyProducts: [],
                studyProductsLangIdFilters: {
                    1: [1, 4], // английский
                    2: [2], // испанский
                    3: [], // немецкий
                    4: [], // французский
                    5: [], // китайский
                    6: [3, 5], // русский
                },
                error: null,
                loading: false,
                ageId: null,
                langId: null,
                diffId: null,
                security: 'security',
                metaDescription: this.$t("course_list_default_description"),
                metaDescriptions: this.$t("course_list_metaDescriptions"),
                metaTitle: this.$t("course_list_default_title"),
                metaTitles: this.$t("course_list_metaTitles")
            }
        },
        metaInfo() {
            return {
                title: this.metaTitle,
                meta: [
                    {vmid: 'description', name: 'description', content: this.metaDescription}
                ]
            }
        },
        mounted() {
            this.loading = true
            this.security = 'asutp'
            if ('age' in this.$route.query) this.ageId = this.$route.query.age
            if ('lang' in this.$route.query) this.langId = this.$route.query.lang
            if ('diff' in this.$route.query) this.diffId = this.$route.query.diff

            if (this.ageId && !this.langId) this.$router.push('/courses?age=' + this.ageId)
            if (!this.ageId && this.langId) this.$router.push('/courses?lang=' + this.langId)
            if (!this.ageId && !this.langId) this.$router.push('/courses')

            const queryParams = new URLSearchParams(this.$route.query).toString();
            this.metaDescription = this.metaDescriptions[queryParams]
            this.metaTitle = this.metaTitles[queryParams]

            console.log(queryParams)
            console.log(this.description)

            courseApi.fetchCoursesWithFilter(this.ageId, this.langId, this.diffId)
                .then(response => {
                    this.courses = response
                    this.loading = false
                })
                .catch(error => {
                    let data = error.response.data
                    this.error = this.pretty(data)
                    this.loading = false
                })

            if (!this.flavorConfig.hideStudyProductsBlock) {
              studyProductApi.fetchStudyProducts()
                  .then(response => {
                    if ('lang' in this.$route.query) {
                      let all = response
                      let filtered = []
                      let ids = this.studyProductsLangIdFilters[this.$route.query.lang]
                      if (ids && ids.length > 0) {
                        all.filter(item => {
                          if (ids.includes(item.idstudyproduct)) {
                            filtered.push(item)
                          }
                        })
                        this.studyProducts = filtered
                      } else {
                        this.studyProducts = []
                      }
                    } else {
                      this.studyProducts = response
                    }
                  })
                  .catch(error => {
                    let data = error.response.data
                    this.error = this.pretty(data)
                    this.loading = false
                  })
            }

            if (isAuthenticated()) userApi.trackEvent('list_course', null)
        },

        methods: {
            order(course, addititionalPackage) {
                if (course.ordered) {
                    if (addititionalPackage) {
                        this.$router.push('/order/' + course.idcourse + '?addonly')
                    } else {
                        this.$router.push('/course/' + course.slug)
                    }
                } else {
                    if (addititionalPackage) {
                        this.$router.push('/order/' + course.idcourse + '?add')
                    } else {
                        this.$router.push('/order/' + course.idcourse)
                    }
                }
            },
            demo(course) {
                if (course.freeLessonsCount > 0) {
                    this.$router.push('/course/' + course.slug)
                } else {
                    this.$router.push('/order/' + course.idcourse)
                }
            },
            pretty(value) {
                if (value.message) {
                    return value.message
                }
                return JSON.stringify(value, null, 2)
            },
            courseDemoButtonLabel(course) {
                if (!course.ordered
                    && course.freeLessonsCount > 0
                    && parseInt(course.price) > 0) {
                    return this.$t('try');
                }
                return null;
            },

            orderSubscription() {
                this.$router.push('/schedule')

            },

            toStudyProduct(studyProduct) {
                window.location.href = `/${studyProduct.slug}.html`
                //this.$router.push('/' + studyProduct.slug)
            }
        }
    }
</script>

<style src="@/assets/hometeacher/css/main.css">
</style>
<style>
    .CourseList {
        background-color: white;
    }
</style>
